import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { formatCurrency, formatDate } from '../../utils/formatters';

const SalesTrendChart = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <div className="h-4 w-32 bg-theme-tertiary rounded mb-4 animate-pulse"></div>
        <div className="h-64 bg-theme-tertiary rounded animate-pulse"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
          <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Sales Trend</h3>
        <div className="h-64 flex items-center justify-center text-theme-muted">
          <p>No sales data available</p>
        </div>
      </div>
    );
  }

  const formattedData = data.map(item => ({
    ...item,
    date: formatDate(item.date),
    displayRevenue: parseFloat(item.revenue || 0)
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-theme-secondary p-3 border border-theme rounded-lg shadow-theme-lg">
          <p className="text-sm font-medium text-theme-muted mb-1">{payload[0].payload.date}</p>
          <p className="text-sm font-semibold text-accent-gold">
            Revenue: {formatCurrency(payload[0].value)}
          </p>
          <p className="text-sm text-theme-secondary">
            Sales: {payload[0].payload.sales_count || 0}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Sales Trend</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="date"
            tick={{ fill: 'var(--color-text-muted)', fontSize: 12 }}
            tickLine={{ stroke: 'var(--color-border)' }}
          />
          <YAxis
            tick={{ fill: 'var(--color-text-muted)', fontSize: 12 }}
            tickLine={{ stroke: 'var(--color-border)' }}
            tickFormatter={(value) => `₦${(value / 1000).toFixed(0)}K`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: '14px', color: 'var(--color-text-primary)' }} />
          <Line
            type="monotone"
            dataKey="displayRevenue"
            stroke="#D4AF37"
            strokeWidth={2}
            dot={{ fill: '#D4AF37', r: 4 }}
            activeDot={{ r: 6 }}
            name="Revenue"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesTrendChart;

